import { render, staticRenderFns } from "./imot-list.vue?vue&type=template&id=011e1a4b"
import script from "./imot-list.vue?vue&type=script&lang=js"
export * from "./imot-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports